import { BaseEntityDTO, IBaseEntityDTO } from './base.entity.dto';
import {
  IPaymentInfoDTO,
  IProductVariantDTO,
  ITeamCriteriaDTO,
  ITeamDTO,
  PaymentInfoDTO,
  ProductVariantDTO,
  TeamCriteriaDTO,
  TeamDTO,
} from './';

export interface IOrderDTO extends IBaseEntityDTO {
  orderId: string;
  transactionId: string;
  amount: number;
  productVariant?: IProductVariantDTO;
  team?: ITeamDTO;
  billing_name: string;
  billing_street_address: string;
  billing_city: string;
  billing_state: string;
  billing_postal_code: string;
  billing_country: string;
  teamCriteria?: ITeamCriteriaDTO;
  card?: IPaymentInfoDTO;
}

export class OrderDTO extends BaseEntityDTO implements IOrderDTO {
  orderId: string;
  transactionId: string;
  amount: number;
  productVariant?: IProductVariantDTO;
  team?: ITeamDTO;
  billing_name: string;
  billing_street_address: string;
  billing_city: string;
  billing_state: string;
  billing_postal_code: string;
  billing_country: string;
  teamCriteria?: ITeamCriteriaDTO;
  card?: IPaymentInfoDTO;

  constructor(data?: Partial<OrderDTO>) {
    super(data);

    this.orderId = data?.orderId ?? '';
    this.transactionId = data?.transactionId ?? '';
    this.amount = data?.amount ?? 0;
    this.productVariant = new ProductVariantDTO(data?.productVariant);
    this.team = data?.team ? new TeamDTO(data.team) : undefined;
    this.billing_name = data?.billing_name ?? '';
    this.billing_street_address = data?.billing_street_address ?? '';
    this.billing_city = data?.billing_city ?? '';
    this.billing_state = data?.billing_state ?? '';
    this.billing_postal_code = data?.billing_postal_code ?? '';
    this.billing_country = data?.billing_country ?? '';
    this.teamCriteria = data?.teamCriteria ? new TeamCriteriaDTO(data.teamCriteria) : undefined;
    this.card = data?.card ? new PaymentInfoDTO(data.card) : undefined;
  }
}
